export default "__VITE_ASSET__a69a7f73__"